import Link from 'next/link'
import { styled } from 'styled-components'

import { FormattedMessage } from '@b-stock/fe-core/bstock-react'
import { Typography } from '@b-stock/fe-core/design-system'

const ToastContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
`

const ViewWatchlistLink = styled(Link)`
  ${Typography.Body3_Semibold}
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
    text-underline-offset: 0.2rem;
  }
`

/**
 * Toast content component for watchlist addition notifications
 */
const WatchlistToastContent = ({
  onViewWatchlistClick,
}: {
  onViewWatchlistClick?: () => void
} = {}) => {
  return (
    <ToastContainer>
      <span>
        <FormattedMessage id="Listing.watchlist.toastText" />
      </span>

      <ViewWatchlistLink
        href="/buy/p/my/watchlist"
        target="_blank"
        rel="noopener noreferrer"
        onClick={onViewWatchlistClick}
      >
        <FormattedMessage id="Listing.watchlist.toastLink" />
      </ViewWatchlistLink>
    </ToastContainer>
  )
}

export default WatchlistToastContent
